import validate from "/Volumes/4TB-PRO-BLADE/projects/mvpProject/website/mvp-website-new/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/Volumes/4TB-PRO-BLADE/projects/mvpProject/website/mvp-website-new/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}